module.exports = __webpack_public_path__ + "img/ref3.9b36250d.png";